export default __webpack_public_path__ + "4956a8eecf7afde55349a32cffacb1ef.jpg";